function TextAreaInput ({label, id, placeholder,size, value}){
  return (
    <div className={`col-span-${size}`}>
      <label htmlFor={id} className="block text-sm font-medium leading-6 text-gray-900">
        {label}
      </label>
      <div className="mt-2">
        <textarea
          id={id}
          name={id}
          rows={3}
          defaultValue={value}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
      </div>
      <p className="mt-3 text-sm leading-6 text-gray-600">{placeholder}</p>
    </div>
  );
}

export default TextAreaInput;